module.exports = __webpack_public_path__ + "static/media/icon-settings.892d8f58.svg";